// extracted by mini-css-extract-plugin
export default {"title":"_3-PJ3A0G7GS_pVgoRbgWT0"};